export const FORM_PATH_PREFIXES = [
  "/leads",
  "/enterprise-intake",
  "/pre-activation",
];

export const REBRAND_BANNER_EXCLUDED_PATH_PREFIXES = [
  "/campaign-approval",
  "/content-approval",
  "/mica",
  "/redirect-mica",
  "/whatsapp-chat-simulator",
];

export const isFormPath = (pathname = "") =>
  FORM_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));

export const isRebrandBannerExcludedPath = (pathname = "") =>
  REBRAND_BANNER_EXCLUDED_PATH_PREFIXES.some((prefix) =>
    pathname.startsWith(prefix)
  );
